import imgDeliverect from 'assets/images/integrations/logos/img_deliverect.svg'
import imgFranpos from 'assets/images/integrations/logos/img_franpos.svg'
import imgGeniusXenial from 'assets/images/integrations/logos/img_genius_xenial.svg'
import imgNcr from 'assets/images/integrations/logos/img_ncr.svg'
import imgOlo from 'assets/images/integrations/logos/img_olo.svg'
import imgParBrink from 'assets/images/integrations/logos/img_par_brink.svg'
import imgQu from 'assets/images/integrations/logos/img_qu.svg'
import imgRevel from 'assets/images/integrations/logos/img_revel.svg'
import imgShift4 from 'assets/images/integrations/logos/img_shift4.svg'
import imgSquare from 'assets/images/integrations/logos/img_square.svg'
import imgTabit from 'assets/images/integrations/logos/img_tabit.svg'
import imgToast from 'assets/images/integrations/logos/img_toast.svg'

const PROVIDER_LOGOS: Record<string, string> = {
  deliverect: imgDeliverect,
  franpos: imgFranpos,
  genius_xenial: imgGeniusXenial,
  ncr: imgNcr,
  olo: imgOlo,
  par_brink: imgParBrink,
  qu: imgQu,
  revel: imgRevel,
  shift4: imgShift4,
  square: imgSquare,
  tabit: imgTabit,
  toast: imgToast,
}

export const providerLogo = (logoKey: string | null): string | null =>
  logoKey ? PROVIDER_LOGOS[logoKey] ?? null : null
